import { render, staticRenderFns } from "./FormComponent.vue?vue&type=template&id=2d7f83ab&"
import script from "./FormComponent.vue?vue&type=script&lang=js&"
export * from "./FormComponent.vue?vue&type=script&lang=js&"
import style0 from "./FormComponent.vue?vue&type=style&index=0&id=2d7f83ab&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports